import React, { useEffect, useMemo, useRef } from "react";
import { SearchGroup } from "../../..";
import { Search } from "@gw/web-basic-components";
import { useSearchGroup } from "../../../search-group/hooks";
import type { InnerSearchProps } from "./dto";

/**
 * 内置搜索框
 */
const InnerSearch = (props: InnerSearchProps) => {
  const { matchType, column, matchValue, onSubmit, ...restProps } = props;

  const timeRef = useRef<NodeJS.Timeout>();

  const { query } = useSearchGroup<IReqPage>();
  /** 查询条件占位索引 */
  const qIndex = useMemo(() => {
    return query?.queryConditions?.findIndex((m) => m?.column === props.column);
  }, [query?.queryConditions]);

  const onClear = () => {
    timeRef.current = setTimeout(() => onSubmit());
  };

  useEffect(() => {
    return () => {
      if (timeRef.current) clearTimeout(timeRef.current);
    };
  }, []);

  return (
    <SearchGroup.Item keyPath={["queryConditions", qIndex, "matchValue"]}>
      <Search
        // TODO onClear 在 onChange 之前执行，如无定时器，则无法捕获更新后的值
        onClear={onClear}
        onSearch={onSubmit}
        {...restProps}
      />
    </SearchGroup.Item>
  );
};

export default InnerSearch;
